import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Lightbulb, RefreshCw, Settings, BarChart, Shield, Eye } from "lucide-react";

export function WhyChooseUs() {
  const reasons = [
    {
      icon: Lightbulb,
      title: "Intelligent Scheme Planning",
      description: "AI-driven insights help you design more effective promotional schemes and procurement strategies."
    },
    {
      icon: RefreshCw,
      title: "Real-time Reconciliation",
      description: "Instant settlement and reconciliation processes eliminate delays and reduce manual errors."
    },
    {
      icon: Settings,
      title: "Rule-based Workflow",
      description: "Customizable automation rules that adapt to your specific business processes and requirements."
    },
    {
      icon: BarChart,
      title: "AI-driven Insights",
      description: "Advanced analytics and predictive capabilities provide actionable intelligence for better decisions."
    },
    {
      icon: Shield,
      title: "Boost Compliance",
      description: "Built-in compliance frameworks and audit trails ensure regulatory adherence and risk management."
    },
    {
      icon: Eye,
      title: "Enhanced Visibility",
      description: "Complete transparency across all operations with real-time dashboards and comprehensive reporting."
    }
  ];

  return (
    <section className="py-16 lg:py-24" style={{ backgroundColor: '#F6FBEA' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 text-3xl lg:text-4xl text-black font-bold">Why NexProcureAI?</h2>
          <p className="text-lg text-muted-foreground">
            Discover the key advantages that make NexProcureAI the preferred choice for modern retail enterprises.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reasons.map((reason, index) => (
            <Card key={index} className="text-center transition-all hover:shadow-md">
              <CardHeader>
                <div 
                  className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
                  style={{ backgroundColor: '#FCFFEF' }}
                >
                  <reason.icon className="h-8 w-8 text-secondary" />
                </div>
                <CardTitle className="text-lg">{reason.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{reason.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}